import { ValueType } from './../../../core/models/enums/core.enums';
export class OptionsConstants {
  static readonly Languages = [
    {
      value: "en",
      viewValue: "English",
      flag: "us",
    },
    {
      value: "fr",
      viewValue: "Français",
      flag: "fr",
    },
  ];

  static readonly NoOfEmployees = [10, 20, 30, 40, 50];

  static readonly Countries = [
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Azerbaijan", code: "AZ" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belgium", code: "BE" },
    { name: "Canada", code: "CA" },
    { name: "China", code: "CN" },
    { name: "Czech Republic", code: "CZ" },
    { name: "Denmark", code: "DK" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "Iceland", code: "IS" },
    { name: "India", code: "IN" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "New Zealand", code: "NZ" },
    { name: "Pakistan", code: "PK" },
    { name: "Peru", code: "PE" },
    { name: "Philippines", code: "PH" },
    { name: "Russian Federation", code: "RU" },
    { name: "RWANDA", code: "RW" },
    { name: "Somalia", code: "SO" },
    { name: "Uganda", code: "UG" },
    { name: "Ukraine", code: "UA" },
    { name: "United Arab Emirates", code: "AE" },
    { name: "United Kingdom", code: "GB" },
    { name: "United States", code: "US" },
    { name: "Yemen", code: "YE" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" },
  ];

  static readonly TimeZones = [
    { label: "(GMT-11:00) Pago Pago", value:  "Pacific/Pago_Pago" },
    { label: "(GMT-10:00) Hawaii Time", value:  "Pacific/Honolulu" },
    { label: "(GMT-08:00) Pacific Time", value:  "America/Los_Angeles" },
    { label: "(GMT-08:00) Pacific Time - Tijuana", value:  "America/Tijuana" },
    { label: "(GMT-07:00) Mountain Time", value:  "America/Denver" },
    { label: "(GMT-07:00) Mountain Time - Arizona", value:  "America/Phoenix" },
    { label: "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan", value:  "America/Mazatlan" },
    { label: "(GMT-06:00) Central Time", value:  "America/Chicago" },
    { label: "(GMT-06:00) Central Time - Mexico City", value:  "America/Mexico_City" },
    { label: "(GMT-06:00) Central Time - Regina", value:  "America/Regina" },
    { label: "(GMT-06:00) Guatemala", value:  "America/Guatemala" },
    { label: "(GMT-05:00) Montego Bay", value:  "America/Jamaica" },
    { label: "(GMT-05:00) Bogota", value:  "America/Bogota" },
    { label: "(GMT-05:00) Eastern Time", value:  "America/New_York" },
    { label: "(GMT-05:00) Lima", value:  "America/Lima" },
    { label: "(GMT-04:30) Caracas", value:  "America/Caracas" },
    { label: "(GMT-04:00) Atlantic Time - Halifax", value:  "America/Halifax" },
    { label: "(GMT-04:00) Guyana", value:  "America/Guyana" },
    { label: "(GMT-04:00) La Paz", value:  "America/La_Paz" },
    { label: "(GMT-03:00) Buenos Aires", value:  "America/Argentina/Buenos_Aires" },
    { label: "(GMT-03:00) Godthab", value:  "America/Godthab" },
    { label: "(GMT-03:00) Montevideo", value:  "America/Montevideo" },
    { label: "(GMT-03:30) Newfoundland Time - St. Johns", value:  "America/St_Johns" },
    { label: "(GMT-03:00) Santiago", value:  "America/Santiago" },
    { label: "(GMT-02:00) Sao Paulo", value:  "America/Sao_Paulo" },
    { label: "(GMT-02:00) South Georgia", value:  "Atlantic/South_Georgia" },
    { label: "(GMT-01:00) Azores", value:  "Atlantic/Azores" },
    { label: "(GMT-01:00) Cape Verde", value:  "Atlantic/Cape_Verde" },
    { label: "(GMT+00:00) Casablanca", value:  "Africa/Casablanca" },
    { label: "(GMT+00:00) Dublin", value:  "Europe/Dublin" },
    { label: "(GMT+00:00) Lisbon", value:  "Europe/Lisbon" },
    { label: "(GMT+00:00) London", value:  "Europe/London" },
    { label: "(GMT+00:00) Monrovia", value:  "Africa/Monrovia" },
    { label: "(GMT+01:00) Algiers", value:  "Africa/Algiers" },
    { label: "(GMT+01:00) Amsterdam", value:  "Europe/Amsterdam" },
    { label: "(GMT+01:00) Berlin", value:  "Europe/Berlin" },
    { label: "(GMT+01:00) Brussels", value:  "Europe/Brussels" },
    { label: "(GMT+01:00) Budapest", value:  "Europe/Budapest" },
    { label: "(GMT+01:00) Central European Time - Belgrade", value:  "Europe/Belgrade" },
    { label: "(GMT+01:00) Central European Time - Prague", value:  "Europe/Prague" },
    { label: "(GMT+01:00) Copenhagen", value:  "Europe/Copenhagen" },
    { label: "(GMT+01:00) Madrid", value:  "Europe/Madrid" },
    { label: "(GMT+01:00) Paris", value:  "Europe/Paris" },
    { label: "(GMT+01:00) Rome", value:  "Europe/Rome" },
    { label: "(GMT+01:00) Stockholm", value:  "Europe/Stockholm" },
    { label: "(GMT+01:00) Vienna", value:  "Europe/Vienna" },
    { label: "(GMT+01:00) Warsaw", value:  "Europe/Warsaw" },
    { label: "(GMT+02:00) Athens", value:  "Europe/Athens" },
    { label: "(GMT+02:00) Bucharest", value:  "Europe/Bucharest" },
    { label: "(GMT+02:00) Cairo", value:  "Africa/Cairo" },
    { label: "(GMT+02:00) Jerusalem", value:  "Asia/Jerusalem" },
    { label: "(GMT+02:00) Johannesburg", value:  "Africa/Johannesburg" },
    { label: "(GMT+02:00) Helsinki", value:  "Europe/Helsinki" },
    { label: "(GMT+02:00) Kiev", value:  "Europe/Kiev" },
    { label: "(GMT+02:00) Moscow-01 - Kaliningrad", value:  "Europe/Kaliningrad" },
    { label: "(GMT+02:00) Riga", value:  "Europe/Riga" },
    { label: "(GMT+02:00) Sofia", value:  "Europe/Sofia" },
    { label: "(GMT+02:00) Tallinn", value:  "Europe/Tallinn" },
    { label: "(GMT+02:00) Vilnius", value:  "Europe/Vilnius" },
    { label: "(GMT+03:00) Istanbul", value:  "Europe/Istanbul" },
    { label: "(GMT+03:00) Baghdad", value:  "Asia/Baghdad" },
    { label: "(GMT+03:00) Nairobi", value:  "Africa/Nairobi" },
    { label: "(GMT+03:00) Minsk", value:  "Europe/Minsk" },
    { label: "(GMT+03:00) Riyadh", value:  "Asia/Riyadh" },
    { label: "(GMT+03:00) Moscow+00 - Moscow", value:  "Europe/Moscow" },
    { label: "(GMT+03:30) Tehran", value:  "Asia/Tehran" },
    { label: "(GMT+04:00) Baku", value:  "Asia/Baku" },
    { label: "(GMT+04:00) Moscow+01 - Samara", value:  "Europe/Samara" },
    { label: "(GMT+04:00) Tbilisi", value:  "Asia/Tbilisi" },
    { label: "(GMT+04:00) Yerevan", value:  "Asia/Yerevan" },
    { label: "(GMT+04:30) Kabul", value:  "Asia/Kabul" },
    { label: "(GMT+05:00) Karachi", value:  "Asia/Karachi" },
    { label: "(GMT+05:00) Moscow+02 - Yekaterinburg", value:  "Asia/Yekaterinburg" },
    { label: "(GMT+05:00) Tashkent", value:  "Asia/Tashkent" },
    { label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi", value:  "Asia/Kolkata" },
    { label: "(GMT+05:30) Colombo", value:  "Asia/Colombo" },
    { label: "(GMT+06:00) Almaty", value:  "Asia/Almaty" },
    { label: "(GMT+06:00) Dhaka", value:  "Asia/Dhaka" },
    { label: "(GMT+06:30) Rangoon", value:  "Asia/Rangoon" },
    { label: "(GMT+07:00) Bangkok", value:  "Asia/Bangkok" },
    { label: "(GMT+07:00) Jakarta", value:  "Asia/Jakarta" },
    { label: "(GMT+07:00) Moscow+04 - Krasnoyarsk", value:  "Asia/Krasnoyarsk" },
    { label: "(GMT+08:00) China Time - Beijing", value:  "Asia/Shanghai" },
    { label: "(GMT+08:00) Hong Kong", value:  "Asia/Hong_Kong" },
    { label: "(GMT+08:00) Kuala Lumpur", value:  "Asia/Kuala_Lumpur" },
    { label: "(GMT+08:00) Moscow+05 - Irkutsk", value:  "Asia/Irkutsk" },
    { label: "(GMT+08:00) Singapore", value:  "Asia/Singapore" },
    { label: "(GMT+08:00) Taipei", value:  "Asia/Taipei" },
    { label: "(GMT+08:00) Ulaanbaatar", value:  "Asia/Ulaanbaatar" },
    { label: "(GMT+08:00) Western Time - Perth", value:  "Australia/Perth" },
    { label: "(GMT+09:00) Moscow+06 - Yakutsk", value:  "Asia/Yakutsk" },
    { label: "(GMT+09:00) Seoul", value:  "Asia/Seoul" },
    { label: "(GMT+09:00) Tokyo", value:  "Asia/Tokyo" },
    { label: "(GMT+09:30) Central Time - Darwin", value:  "Australia/Darwin" },
    { label: "(GMT+10:00) Eastern Time - Brisbane", value:  "Australia/Brisbane" },
    { label: "(GMT+10:00) Guam", value:  "Pacific/Guam" },
    { label: "(GMT+10:00) Moscow+07 - Magadan", value:  "Asia/Magadan" },
    { label: "(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk", value:  "Asia/Vladivostok" },
    { label: "(GMT+10:00) Port Moresby", value:  "Pacific/Port_Moresby" },
    { label: "(GMT+10:30) Central Time - Adelaide", value:  "Australia/Adelaide" },
    { label: "(GMT+11:00) Eastern Time - Hobart", value:  "Australia/Hobart" },
    { label: "(GMT+11:00) Eastern Time - Melbourne, Sydney", value:  "Australia/Sydney" },
    { label: "(GMT+11:00) Guadalcanal", value:  "Pacific/Guadalcanal" },
    { label: "(GMT+11:00) Noumea", value:  "Pacific/Noumea" },
    { label: "(GMT+12:00) Majuro", value:  "Pacific/Majuro" },
    { label: "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy", value:  "Asia/Kamchatka" },
    { label: "(GMT+13:00) Auckland", value:  "Pacific/Auckland" },
    { label: "(GMT+13:00) Fakaofo", value:  "Pacific/Fakaofo" },
    { label: "(GMT+13:00) Fiji", value:  "Pacific/Fiji" },
    { label: "(GMT+13:00) Tongatapu", value:  "Pacific/Tongatapu" },
    { label: "(GMT+14:00) Apia", value:  "Pacific/Apia" }
  ]

  static readonly ValueTypes = [
    { label: "Text", value: ValueType.TEXT},
    { label: "Yes/No", value: ValueType.YES_NO},
    { label: "Whole Number", value: ValueType.WHOLE_NUMBER},
    { label: "Decimal Number", value: ValueType.DECIMAL_NUMBER},
    { label: "Phone", value: ValueType.PHONE},
    { label: "Email", value: ValueType.EMAIL},
    { label: "Date", value: ValueType.DATE}
  ]
}

// export const Countries = [
//     {name: "Afghanistan", code: "AF"},
//     {name: "land Islands", code: "AX"},
//     {name: "Albania", code: "AL"},
//     {name: "Algeria", code: "DZ"},
//     {name: "American Samoa", code: "AS"},
//     {name: "AndorrA", code: "AD"},
//     {name: "Angola", code: "AO"},
//     {name: "Anguilla", code: "AI"},
//     {name: "Antarctica", code: "AQ"},
//     {name: "Antigua and Barbuda", code: "AG"},
//     {name: "Argentina", code: "AR"},
//     {name: "Armenia", code: "AM"},
//     {name: "Aruba", code: "AW"},
//     {name: "Australia", code: "AU"},
//     {name: "Austria", code: "AT"},
//     {name: "Azerbaijan", code: "AZ"},
//     {name: "Bahamas", code: "BS"},
//     {name: "Bahrain", code: "BH"},
//     {name: "Bangladesh", code: "BD"},
//     {name: "Barbados", code: "BB"},
//     {name: "Belarus", code: "BY"},
//     {name: "Belgium", code: "BE"},
//     {name: "Belize", code: "BZ"},
//     {name: "Benin", code: "BJ"},
//     {name: "Bermuda", code: "BM"},
//     {name: "Bhutan", code: "BT"},
//     {name: "Bolivia", code: "BO"},
//     {name: "Bosnia and Herzegovina", code: "BA"},
//     {name: "Botswana", code: "BW"},
//     {name: "Bouvet Island", code: "BV"},
//     {name: "Brazil", code: "BR"},
//     {name: "British Indian Ocean Territory", code: "IO"},
//     {name: "Brunei Darussalam", code: "BN"},
//     {name: "Bulgaria", code: "BG"},
//     {name: "Burkina Faso", code: "BF"},
//     {name: "Burundi", code: "BI"},
//     {name: "Cambodia", code: "KH"},
//     {name: "Cameroon", code: "CM"},
//     {name: "Canada", code: "CA"},
//     {name: "Cape Verde", code: "CV"},
//     {name: "Cayman Islands", code: "KY"},
//     {name: "Central African Republic", code: "CF"},
//     {name: "Chad", code: "TD"},
//     {name: "Chile", code: "CL"},
//     {name: "China", code: "CN"},
//     {name: "Christmas Island", code: "CX"},
//     {name: "Cocos (Keeling) Islands", code: "CC"},
//     {name: "Colombia", code: "CO"},
//     {name: "Comoros", code: "KM"},
//     {name: "Congo", code: "CG"},
//     {name: "Congo, The Democratic Republic of the", code: "CD"},
//     {name: "Cook Islands", code: "CK"},
//     {name: "Costa Rica", code: "CR"},
//     {name: "Cote D\"Ivoire", code: "CI"},
//     {name: "Croatia", code: "HR"},
//     {name: "Cuba", code: "CU"},
//     {name: "Cyprus", code: "CY"},
//     {name: "Czech Republic", code: "CZ"},
//     {name: "Denmark", code: "DK"},
//     {name: "Djibouti", code: "DJ"},
//     {name: "Dominica", code: "DM"},
//     {name: "Dominican Republic", code: "DO"},
//     {name: "Ecuador", code: "EC"},
//     {name: "Egypt", code: "EG"},
//     {name: "El Salvador", code: "SV"},
//     {name: "Equatorial Guinea", code: "GQ"},
//     {name: "Eritrea", code: "ER"},
//     {name: "Estonia", code: "EE"},
//     {name: "Ethiopia", code: "ET"},
//     {name: "Falkland Islands (Malvinas)", code: "FK"},
//     {name: "Faroe Islands", code: "FO"},
//     {name: "Fiji", code: "FJ"},
//     {name: "Finland", code: "FI"},
//     {name: "France", code: "FR"},
//     {name: "French Guiana", code: "GF"},
//     {name: "French Polynesia", code: "PF"},
//     {name: "French Southern Territories", code: "TF"},
//     {name: "Gabon", code: "GA"},
//     {name: "Gambia", code: "GM"},
//     {name: "Georgia", code: "GE"},
//     {name: "Germany", code: "DE"},
//     {name: "Ghana", code: "GH"},
//     {name: "Gibraltar", code: "GI"},
//     {name: "Greece", code: "GR"},
//     {name: "Greenland", code: "GL"},
//     {name: "Grenada", code: "GD"},
//     {name: "Guadeloupe", code: "GP"},
//     {name: "Guam", code: "GU"},
//     {name: "Guatemala", code: "GT"},
//     {name: "Guernsey", code: "GG"},
//     {name: "Guinea", code: "GN"},
//     {name: "Guinea-Bissau", code: "GW"},
//     {name: "Guyana", code: "GY"},
//     {name: "Haiti", code: "HT"},
//     {name: "Heard Island and Mcdonald Islands", code: "HM"},
//     {name: "Holy See (Vatican City State)", code: "VA"},
//     {name: "Honduras", code: "HN"},
//     {name: "Hong Kong", code: "HK"},
//     {name: "Hungary", code: "HU"},
//     {name: "Iceland", code: "IS"},
//     {name: "India", code: "IN"},
//     {name: "Indonesia", code: "ID"},
//     {name: "Iran, Islamic Republic Of", code: "IR"},
//     {name: "Iraq", code: "IQ"},
//     {name: "Ireland", code: "IE"},
//     {name: "Isle of Man", code: "IM"},
//     {name: "Israel", code: "IL"},
//     {name: "Italy", code: "IT"},
//     {name: "Jamaica", code: "JM"},
//     {name: "Japan", code: "JP"},
//     {name: "Jersey", code: "JE"},
//     {name: "Jordan", code: "JO"},
//     {name: "Kazakhstan", code: "KZ"},
//     {name: "Kenya", code: "KE"},
//     {name: "Kiribati", code: "KI"},
//     {name: "Korea, Democratic People\"S Republic of", code: "KP"},
//     {name: "Korea, Republic of", code: "KR"},
//     {name: "Kuwait", code: "KW"},
//     {name: "Kyrgyzstan", code: "KG"},
//     {name: "Lao People\"S Democratic Republic", code: "LA"},
//     {name: "Latvia", code: "LV"},
//     {name: "Lebanon", code: "LB"},
//     {name: "Lesotho", code: "LS"},
//     {name: "Liberia", code: "LR"},
//     {name: "Libyan Arab Jamahiriya", code: "LY"},
//     {name: "Liechtenstein", code: "LI"},
//     {name: "Lithuania", code: "LT"},
//     {name: "Luxembourg", code: "LU"},
//     {name: "Macao", code: "MO"},
//     {name: "Macedonia, The Former Yugoslav Republic of", code: "MK"},
//     {name: "Madagascar", code: "MG"},
//     {name: "Malawi", code: "MW"},
//     {name: "Malaysia", code: "MY"},
//     {name: "Maldives", code: "MV"},
//     {name: "Mali", code: "ML"},
//     {name: "Malta", code: "MT"},
//     {name: "Marshall Islands", code: "MH"},
//     {name: "Martinique", code: "MQ"},
//     {name: "Mauritania", code: "MR"},
//     {name: "Mauritius", code: "MU"},
//     {name: "Mayotte", code: "YT"},
//     {name: "Mexico", code: "MX"},
//     {name: "Micronesia, Federated States of", code: "FM"},
//     {name: "Moldova, Republic of", code: "MD"},
//     {name: "Monaco", code: "MC"},
//     {name: "Mongolia", code: "MN"},
//     {name: "Montenegro", code: "ME"},
//     {name: "Montserrat", code: "MS"},
//     {name: "Morocco", code: "MA"},
//     {name: "Mozambique", code: "MZ"},
//     {name: "Myanmar", code: "MM"},
//     {name: "Namibia", code: "NA"},
//     {name: "Nauru", code: "NR"},
//     {name: "Nepal", code: "NP"},
//     {name: "Netherlands", code: "NL"},
//     {name: "Netherlands Antilles", code: "AN"},
//     {name: "New Caledonia", code: "NC"},
//     {name: "New Zealand", code: "NZ"},
//     {name: "Nicaragua", code: "NI"},
//     {name: "Niger", code: "NE"},
//     {name: "Nigeria", code: "NG"},
//     {name: "Niue", code: "NU"},
//     {name: "Norfolk Island", code: "NF"},
//     {name: "Northern Mariana Islands", code: "MP"},
//     {name: "Norway", code: "NO"},
//     {name: "Oman", code: "OM"},
//     {name: "Pakistan", code: "PK"},
//     {name: "Palau", code: "PW"},
//     {name: "Palestinian Territory, Occupied", code: "PS"},
//     {name: "Panama", code: "PA"},
//     {name: "Papua New Guinea", code: "PG"},
//     {name: "Paraguay", code: "PY"},
//     {name: "Peru", code: "PE"},
//     {name: "Philippines", code: "PH"},
//     {name: "Pitcairn", code: "PN"},
//     {name: "Poland", code: "PL"},
//     {name: "Portugal", code: "PT"},
//     {name: "Puerto Rico", code: "PR"},
//     {name: "Qatar", code: "QA"},
//     {name: "Reunion", code: "RE"},
//     {name: "Romania", code: "RO"},
//     {name: "Russian Federation", code: "RU"},
//     {name: "RWANDA", code: "RW"},
//     {name: "Saint Helena", code: "SH"},
//     {name: "Saint Kitts and Nevis", code: "KN"},
//     {name: "Saint Lucia", code: "LC"},
//     {name: "Saint Pierre and Miquelon", code: "PM"},
//     {name: "Saint Vincent and the Grenadines", code: "VC"},
//     {name: "Samoa", code: "WS"},
//     {name: "San Marino", code: "SM"},
//     {name: "Sao Tome and Principe", code: "ST"},
//     {name: "Saudi Arabia", code: "SA"},
//     {name: "Senegal", code: "SN"},
//     {name: "Serbia", code: "RS"},
//     {name: "Seychelles", code: "SC"},
//     {name: "Sierra Leone", code: "SL"},
//     {name: "Singapore", code: "SG"},
//     {name: "Slovakia", code: "SK"},
//     {name: "Slovenia", code: "SI"},
//     {name: "Solomon Islands", code: "SB"},
//     {name: "Somalia", code: "SO"},
//     {name: "South Africa", code: "ZA"},
//     {name: "South Georgia and the South Sandwich Islands", code: "GS"},
//     {name: "Spain", code: "ES"},
//     {name: "Sri Lanka", code: "LK"},
//     {name: "Sudan", code: "SD"},
//     {name: "Suriname", code: "SR"},
//     {name: "Svalbard and Jan Mayen", code: "SJ"},
//     {name: "Swaziland", code: "SZ"},
//     {name: "Sweden", code: "SE"},
//     {name: "Switzerland", code: "CH"},
//     {name: "Syrian Arab Republic", code: "SY"},
//     {name: "Taiwan, Province of China", code: "TW"},
//     {name: "Tajikistan", code: "TJ"},
//     {name: "Tanzania, United Republic of", code: "TZ"},
//     {name: "Thailand", code: "TH"},
//     {name: "Timor-Leste", code: "TL"},
//     {name: "Togo", code: "TG"},
//     {name: "Tokelau", code: "TK"},
//     {name: "Tonga", code: "TO"},
//     {name: "Trinidad and Tobago", code: "TT"},
//     {name: "Tunisia", code: "TN"},
//     {name: "Turkey", code: "TR"},
//     {name: "Turkmenistan", code: "TM"},
//     {name: "Turks and Caicos Islands", code: "TC"},
//     {name: "Tuvalu", code: "TV"},
//     {name: "Uganda", code: "UG"},
//     {name: "Ukraine", code: "UA"},
//     {name: "United Arab Emirates", code: "AE"},
//     {name: "United Kingdom", code: "GB"},
//     {name: "United States", code: "US"},
//     {name: "United States Minor Outlying Islands", code: "UM"},
//     {name: "Uruguay", code: "UY"},
//     {name: "Uzbekistan", code: "UZ"},
//     {name: "Vanuatu", code: "VU"},
//     {name: "Venezuela", code: "VE"},
//     {name: "Viet Nam", code: "VN"},
//     {name: "Virgin Islands, British", code: "VG"},
//     {name: "Virgin Islands, U.S.", code: "VI"},
//     {name: "Wallis and Futuna", code: "WF"},
//     {name: "Western Sahara", code: "EH"},
//     {name: "Yemen", code: "YE"},
//     {name: "Zambia", code: "ZM"},
//     {name: "Zimbabwe", code: "ZW"}
//     ]
